// InputController.js — arrow keys + touch swipe -> orthogonal move intents.
// Diagonal input is impossible by construction: keys map 1:1 to a single axis,
// and swipes resolve to the dominant axis only. Knows no game rules.

const KEY_DIRS = {
    ArrowUp: "up",
    ArrowDown: "down",
    ArrowLeft: "left",
    ArrowRight: "right",
};

const SWIPE_THRESHOLD = 30; // px

export class InputController {
    constructor(engine, targetEl = window) {
        this._engine = engine;
        this._target = targetEl;
        this._touchStart = null;

        this._onKeyDown = this._onKeyDown.bind(this);
        this._onTouchStart = this._onTouchStart.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);
    }

    attach() {
        window.addEventListener("keydown", this._onKeyDown);
        this._target.addEventListener("touchstart", this._onTouchStart, { passive: true });
        this._target.addEventListener("touchend", this._onTouchEnd, { passive: true });
    }

    detach() {
        window.removeEventListener("keydown", this._onKeyDown);
        this._target.removeEventListener("touchstart", this._onTouchStart);
        this._target.removeEventListener("touchend", this._onTouchEnd);
    }

    _onKeyDown(e) {
        const dir = KEY_DIRS[e.key];
        if (!dir) return;
        e.preventDefault();
        this._engine.move(dir);
    }

    _onTouchStart(e) {
        const t = e.changedTouches[0];
        this._touchStart = { x: t.clientX, y: t.clientY };
    }

    _onTouchEnd(e) {
        if (!this._touchStart) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - this._touchStart.x;
        const dy = t.clientY - this._touchStart.y;
        this._touchStart = null;

        if (Math.abs(dx) < SWIPE_THRESHOLD && Math.abs(dy) < SWIPE_THRESHOLD) return;

        // Dominant axis only -> never diagonal.
        if (Math.abs(dx) > Math.abs(dy)) {
            this._engine.move(dx > 0 ? "right" : "left");
        } else {
            this._engine.move(dy > 0 ? "down" : "up");
        }
    }
}
